import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HomeCategories() {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            快速导航
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            选择您关心的分类，快速找到所需信息
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 text-center transition-all hover:bg-primary-500 hover:text-white cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-white/20 group-hover:text-white transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs mt-1 text-foreground-500 group-hover:text-white/80 line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}